import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up-down--sprite",
  "use": "arrow-up-down--sprite-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-up-down--sprite\">\n<path d=\"M6.54 3.795L5 5.335L3.46 3.795L2.75 4.5L5 6.75L7.25 4.5L6.54 3.795ZM5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM5 9C2.79 9 1 7.21 1 5C1 2.79 2.79 1 5 1C7.21 1 9 2.79 9 5C9 7.21 7.21 9 5 9Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol